import React from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { Calendar, Shield } from 'lucide-react';

const ReglementationsAnj2025 = () => {
  return (
    <div className="min-h-screen bg-gray-900">
      <Header />
      <main className="py-12 md:py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <article className="bg-gray-800 rounded-2xl p-8 md:p-12 border border-gray-700">
              <div className="flex items-center text-gray-400 text-sm mb-4">
                <Calendar size={16} className="mr-2" />
                <span>15.11.2025</span>
                <span className="mx-2">•</span>
                <span className="text-pink-400">Réglementation</span>
              </div>
              
              <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
                Nouvelles Réglementations ANJ en 2025
              </h1>
              
              <div className="prose prose-invert max-w-none">
                <p className="text-xl text-gray-300 mb-8 leading-relaxed">
                  L'Autorité Nationale des Jeux continue d'évoluer et d'affiner sa réglementation du secteur des paris en ligne français. Les changements de 2025 apportent des modifications significatives qui impactent directement votre expérience en tant que parieur. Comprendre ces évolutions réglementaires vous permet non seulement de rester conforme, mais aussi d'identifier les nouvelles opportunités et protections qui en découlent.
                </p>

                <section className="mb-10">
                  <h2 className="text-3xl font-bold text-white mb-4">Renforcement des Obligations de Protection</h2>
                  <p className="text-gray-300 leading-relaxed mb-4">
                    L'ANJ a renforcé en 2025 les obligations des opérateurs en matière de protection des parieurs. Les sites doivent désormais proposer des outils de jeu responsable plus accessibles et plus complets. Les limites de dépôt et de perte doivent être configurables dès l'ouverture du compte, et les rappels de temps de jeu sont obligatoires pour tous les sites.
                  </p>
                  <p className="text-gray-300 leading-relaxed mb-4">
                    Ces obligations renforcées signifient que vous bénéficiez maintenant de protections plus robustes par défaut. Vous n'avez plus besoin de chercher activement ces outils : ils sont proposés automatiquement et de manière visible. Cette évolution rend le jeu responsable plus accessible à tous les parieurs, pas seulement à ceux qui le cherchent activement.
                  </p>
                </section>

                <section className="mb-10">
                  <h2 className="text-3xl font-bold text-white mb-4">Nouvelles Règles sur les Bonus</h2>
                  <p className="text-gray-300 leading-relaxed mb-4">
                    L'ANJ a imposé des règles plus strictes sur la communication des bonus. Les conditions de mise doivent maintenant être affichées de manière claire et accessible avant l'acceptation, et les wagers supérieurs à x10 sont soumis à des obligations d'information renforcées. Ces changements vous permettent de mieux évaluer la valeur réelle des bonus avant de vous engager.
                  </p>
                  <p className="text-gray-300 leading-relaxed mb-4">
                    Les sites ne peuvent plus "cacher" les conditions dans les petits caractères. Toutes les restrictions importantes doivent être visibles et compréhensibles avant que vous n'acceptiez un bonus. Cette transparence forcée améliore votre capacité à faire des choix éclairés et à éviter les pièges marketing.
                  </p>
                </section>

                <section className="mb-10">
                  <h2 className="text-3xl font-bold text-white mb-4">Évolutions sur les Retraits</h2>
                  <p className="text-gray-300 leading-relaxed mb-4">
                    Les nouvelles réglementations imposent des délais maximum pour le traitement des retraits : 48 heures pour la plupart des méthodes de paiement standard. Les sites qui dépassent régulièrement ces délais peuvent être sanctionnés. Cette évolution garantit que vous accédez plus rapidement à vos gains.
                  </p>
                  <p className="text-gray-300 leading-relaxed mb-4">
                    Les sites doivent également informer clairement des délais de traitement avant que vous n'initiiez un retrait. Cette transparence vous permet de planifier vos retraits en connaissance de cause et de choisir les méthodes les plus rapides selon vos besoins.
                  </p>
                </section>

                <section className="mb-10">
                  <h2 className="text-3xl font-bold text-white mb-4">Impact sur Votre Stratégie</h2>
                  <p className="text-gray-300 leading-relaxed mb-4">
                    Ces réglementations créent des opportunités : les sites qui s'adaptent rapidement offrent souvent de meilleures conditions pour se conformer strictement. Les parieurs informés peuvent identifier ces avantages et en profiter avant que la concurrence ne suive.
                  </p>
                  <p className="text-gray-300 leading-relaxed mb-4">
                    Restez informé des évolutions réglementaires pour adapter votre stratégie. Les changements créent souvent des déséquilibres temporaires que les parieurs avertis peuvent exploiter avant que le marché ne se rééquilibre.
                  </p>
                </section>
              </div>
            </article>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default ReglementationsAnj2025;

